import { defineStore } from 'pinia';
export const useUploadFileChunksStore = defineStore('uploadFileChunks', () => {
  const uploadFileChunksList = ref([]);
  const setUploadFileChunksList = item => {
    if (Array.isArray(item)) {
      uploadFileChunksList.value = [...item];
    } else {
      uploadFileChunksList.value = [item];
    }
  };
  return {
    uploadFileChunksList,
    setUploadFileChunksList
  };
});